
/* SEARCH-AND-FILL */
// Inicializa o comportamento dos campos do tipo PESQUISAR E PREENCHER
// Executada no load da wfflow_Execute

execv2.form.processSearchAndFillError = function (label, message) {
    console.log(label + "\n" + message);
}
execv2.form.processSearchAndFill_Process = function (field, btn, timeout, container, key_to_codfield) {
    var label = field.getAttribute("label");
    btn.setAttribute("disabled", "disabled");

    //como clicou no botão, cancela o timer que ira apagar o valor do campo
    clearTimeout(timeout);

    //tira a cor de preenchimento
    container.classList.remove("info");
    container.classList.remove("error");

    var qs = "";
    var c = field.getAttribute("data-c");
    var query = field.value;

    //limpa todos os campos associados antes preenchidos
    var others_altered = field.getAttribute("others_altered") != null ? field.getAttribute("others_altered").split(",") : [];
    others_altered.forEach(function (k, i) {
        execv2.form.fillValue(k, "", field);
    });

    //mostra loading ajax
    if (!container.querySelector(".loading")) {
        if (container.querySelectorAll(".loading").length == 0) {
            let img = document.createElement('img');
            img.src = "../common/images/v3/loading_ajax.gif";
            img.width = 16;
            img.className = "loading";
            container.appendChild(img);
        }
    }

    var dependencies = [];
    let dataDependencies = field.getAttribute("data-dependencies");

    if (dataDependencies)
        dependencies = dataDependencies.split(",");

    //monta queryString com valores das dependencias
    for (const element of dependencies) {
        if (qs != "") {
            qs += "&";
        }

        var xname = "inp" + element;
        var xvalue = null;
        var dependencyElementAll = document.forms[0].querySelectorAll("[xname='" + xname + "']");
        if (dependencyElementAll.length == 1) {
            xvalue = dependencyElementAll[0].value;
        }
        else {
            var dependencyElement = field.closest("tr").querySelector("[xname='" + xname + "']");
            if (dependencyElement)
                xvalue = dependencyElement.value;
        }

        if (xvalue == null)
            xvalue = "";

        qs += xname + "=" + xvalue;
    }

    //consulta a fonte de dados
    h.postJSON(
        "../api/internal/legacy/1.0/datasource/get/1.0/" + c + "?" + (qs != "" ? "&" + qs : ""),
        function (data) {
            if (data.success != null) {
                var found = false;

                //para cada item de retorno
                data.success.forEach(function (item, i) {
                    //se o texto é igual ao texto pesquisado ou não tem texto de retorno para pesquisar
                    if (!found && (item.txt.toLowerCase() == "" || item.txt.toLowerCase() == query.toLowerCase())) {
                        found = true;

                        //preencha aqui o valor do campo codigo (cod+identificador)
                        execv2.form.fillValue(key_to_codfield, item.cod, field);

                        //para cada campo associado
                        let fieldValueMap = new Map(Object.entries(item.fields));

                        fieldValueMap.forEach(function (v, k) {
                            if ("inp" + k != field.getAttribute("xname")) {
                                execv2.form.fillValue(k, v, field);

                                if (others_altered.includes(k) == false) {
                                    others_altered.push(k)
                                }
                            }
                        });
                        field.setAttribute("others_altered", others_altered);
                    }
                });
                //não achou nada procurado, mostra mensagem amigavel de erro
                if (!found) {
                    field.value = '';
                    field.dispatchEvent(new Event("change"));
                    container.classList.add("error");

                    //limpa todos os campos associados antes preenchidos
                    others_altered = field.getAttribute("others_altered") != null ? field.getAttribute("others_altered").split(",") : [];
                    others_altered.forEach(function (k, i) {
                        execv2.form.fillValue(k, "", field);
                    });
                }
            } else if (data.error != null) {
                execv2.form.processSearchAndFillError(label, data.error.FriendlyMessage);
            }

            // always
            container.querySelectorAll('.loading').forEach((el) => { container.removeChild(el); });
            btn.disabled = false;
        },
        function (jqXHR, textStatus, errorThrown) {
            execv2.form.processSearchAndFillError(label, errorThrown);

            // always
            container.querySelectorAll('.loading').forEach((el) => { container.removeChild(el); });
            btn.disabled = false;
        });
}

execv2.form.processSearchAndFill = function() {

    //todos os elementos do tipo pesquisar e preencher
    document.querySelectorAll("input[data-special-type='search-and-fill']").forEach(function (field, index) {
        var timeout;
        var container = field.closest(".search-and-fill-container");

        var fieldXname = field.getAttribute("xname");
        //o botao associado a esse elemento
        var btn = field.parentNode.querySelector("button[data-search-and-fill-for='" + fieldXname + "']");
        if (btn) {
            //o elemento que armazena o codigo
            //se encontrar mais de um, quer dizer que é uma tabela MV, então procura de outra maneira, na linha
            var key_to_codfield = "cod" + field.getAttribute("xname").replace("inp", "");

            //ao clicar no botão ao lado do elemento
            btn.addEventListener("click", function () { execv2.form.processSearchAndFill_Process(field, btn, timeout, container, key_to_codfield) });
        }

        field.addEventListener("keypress", function (event) {
            if (field.value != "") {
                container.classList.add("info");
            }
        });

        //Salvar valor antes da possivel alteracao para ser comparado e utilizado na operacao de blur
        field.addEventListener("focus", function (event) {
            field.setAttribute('old-value', field.value);
        });

        //ao tirar o foco do campo
        field.addEventListener("blur", function (event) {
            if (field.value != field.getAttribute("old-value")) {
                //espera 5 segundos para apagar o conteudo
                timeout = setTimeout(function () {
                    //limpa todos os campos associados antes preenchidos
                    var others_altered = field.getAttribute("others_altered") != null ? field.getAttribute("others_altered").split(",") : [];
                    others_altered.forEach(function (k, i) {
                        execv2.form.fillValue(k, "", field);
                    });
                    container.classList.remove("info");
                }, 3000);
            }
        });

        field.addEventListener("focus", function () {
            container.classList.remove("error");
            clearTimeout(timeout);
        });
    });
}
